import { useApp } from "@/context/AppContext";
import { useVolumeKeyUnmute, VOLUME_PRIORITY } from "@/lib/volumeKeys";

// Lot 638 — cible de PLUS BASSE priorité : une touche de volume hors Reels / story / direct réactive le son des vidéos
// du fil (VideoPlayer inline, image + musique) via la préférence partagée videoMuted (mémorisée comme un tap sur 🔇).
export const VolumeKeyBridge = () => {
  const { setVideoMuted } = useApp();
  useVolumeKeyUnmute(true, VOLUME_PRIORITY.FEED, () => setVideoMuted(false));
  return null;
};

export default VolumeKeyBridge;
